import { getWithdrawalStatusDisplay } from '../../utils/withdrawalStatusDisplay';

type Props = {
  status: string | null | undefined;
  className?: string;
};

export default function WithdrawalStatusBadge({ status, className = '' }: Props) {
  const display = getWithdrawalStatusDisplay(status);

  return (
    <span
      className={`inline-flex rounded-full border px-2.5 py-0.5 text-xs font-semibold ${display.className} ${className}`.trim()}
    >
      {display.label}
    </span>
  );
}
